import { createActions } from 'redux-actions';

export const {
	showMenu,
	setCaption,
	disableCaption,
	setPagination,
	blockUI,
	unblockUI,
	showSideDrawer,
	closeSideDrawer
} = createActions(
	'SHOW_MENU',
	'SET_CAPTION',
	'DISABLE_CAPTION',
	'SET_PAGINATION',
	'BLOCK_UI',
	'UNBLOCK_UI',
	'SHOW_SIDE_DRAWER',
	'CLOSE_SIDE_DRAWER'
);
